
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Status = 'published' | 'draft' | 'pending' | 'approved' | 'rejected' | 'paid' | 'open' | 'in_progress' | 'resolved' | 'closed';

interface StatusBadgeProps {
  status: Status;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const getStatusColor = (status: Status) => {
    switch (status) {
      case 'published':
      case 'paid':
      case 'resolved':
      case 'closed':
        return 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100';
      case 'approved':
        return 'bg-blue-100 text-blue-800 border-blue-200 hover:bg-blue-100';
      case 'draft':
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200 hover:bg-yellow-100';
      case 'in_progress':
        return 'bg-indigo-100 text-indigo-800 border-indigo-200 hover:bg-indigo-100';
      case 'rejected':
        return 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100';
      case 'open':
        return 'bg-orange-100 text-orange-800 border-orange-200 hover:bg-orange-100';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100';
    }
  };

  const getLabel = (status: Status) => {
    return status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ');
  };

  return (
    <Badge 
      variant="outline"
      className={cn("font-medium", getStatusColor(status), className)}
    >
      {getLabel(status)}
    </Badge>
  );
};

export default StatusBadge;
